import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useActions, useTypedSelector } from '../../../hooks'
import { getSlug } from '../../../utils'
import { clubRoute } from '../routes'
import { isClubMember } from '../utils'
import { useClub } from './useClub'

export const useClubRegistration = () => {
  const {
    getClubTrack,
    getClubMembership,
    getOffers,
    clearOffers,
    clearClubDetails,
    clearClubMembership,
    clearClubTrack,
  } = useActions()
  const navigate = useNavigate()
  const club = useClub()
  const { track, membership } = useTypedSelector(({ clubs }) => clubs)
  const { isAuthenticated } = useTypedSelector(({ auth }) => auth)
  const { profile } = useTypedSelector(({ user }) => user)
  const { geoIpCountry } = useTypedSelector(({ geoIp }) => geoIp)
  const { offers } = useTypedSelector(({ billing }) => billing)
  const [loaded, setLoaded] = useState(false)
  const [ready, setReady] = useState(false)

  useEffect(
    () => () => {
      clearOffers()
      clearClubMembership()
      clearClubTrack()
    },
    [clearOffers, clearClubDetails, clearClubMembership, clearClubTrack]
  )

  // get club track and club membership
  useEffect(() => {
    if (!club) return

    const trackId = club?.track?.id
    if (trackId) getClubTrack(trackId)

    if (!!profile.data && profile.data.id) {
      getClubMembership(club.id, profile.data.id)
    }
  }, [getClubTrack, club, getClubMembership, profile.data])

  /**
   * If the club is not the currently open club and the
   * user is not a member, then redirect the user to the
   * currently open club
   */
  useEffect(() => {
    if (!track.data || !club) return

    const member = isClubMember(membership.data, isAuthenticated)
    const currentlyOpenId = track.data.currently_open?.id

    if (!currentlyOpenId) {
      return setReady(true)
    }

    const openClub = currentlyOpenId === club.id

    if (member || openClub) {
      return setReady(true)
    } else {
      const slug = getSlug(track.data.currently_open?.url)
      const to = clubRoute({ slug, clubType: 'career' })

      return navigate(to)
    }
  }, [navigate, club, isAuthenticated, membership.data, track.data])

  // get offers for club
  useEffect(() => {
    if (club && ready) {
      getOffers({
        id: club.id,
        query: 'club',
        country: geoIpCountry.data?.country.iso_code,
      })
    }
  }, [getOffers, club, geoIpCountry.data, ready])

  // check if offers fetched and load the content
  useEffect(() => {
    if (offers.data) return setLoaded(true)
  }, [offers.data])

  return { loaded }
}
